module.exports = __webpack_public_path__ + "static/media/Feldspar.eb98f360.jpg";